import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
import _objectSpread from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
/*eslint-disable*/
import request from '@/utils/request';
export function add(data) {
  return request({
    url: 'api/workOrderType',
    method: 'post',
    data: data
  });
}
export function edit(data) {
  return request({
    url: 'api/workOrderType',
    method: 'put',
    data: data
  });
}
export function del(ids) {
  return request({
    url: 'api/workOrderType',
    method: 'delete',
    data: ids
  });
}

/**
 * 一键生成
 *
 * @param data
 */
export function create() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: 'api/workOrderType/addByTemplate',
    method: 'post',
    data: data
  });
}

/**
 * 启用/停用
 *
 * @param data {Object<{ ids: string[], status: number }>}
 */
export function status() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: 'api/workOrderType/status',
    method: 'post',
    data: data
  });
}

/**
 * 获取已选资源
 *
 * @param params {Object<{ workOrderTypeCode: string }>}
 * @return {Promise<Array>}
 */
export function selectedResourceIds() {
  return _selectedResourceIds.apply(this, arguments);
}

/**
 * 绑定资源
 *
 * @param params {Object<{ resourceList: string[], workOrderTypeCodeList: string[] }>}
 */
function _selectedResourceIds() {
  _selectedResourceIds = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var params,
      data,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          params = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          _context.prev = 1;
          _context.next = 4;
          return request({
            url: 'api/workOrderType/bind-resource-one-detail',
            method: 'post',
            data: params
          });
        case 4:
          data = _context.sent;
          return _context.abrupt("return", data || []);
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](1);
          return _context.abrupt("return", []);
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 8]]);
  }));
  return _selectedResourceIds.apply(this, arguments);
}
export function bindResource() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: 'api/workOrderType/bind-resource-batch',
    method: 'post',
    data: params
  });
}

/**
 * 绑定处理单位
 *
 * @param params {Object<{ defaultDealUnitId: string, defaultDealUnitTypeNum: number, ids: string[] }>}
 */
export function bindCompany() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: 'api/workOrderType/setDefaultDealUnitBatch',
    method: 'post',
    data: params
  });
}

/**
 * 获取工单类型字典
 *
 * @param params
 * @param valueKey {string} 默认code
 * @return {Promise<Array>}
 */
export function loadWorkOrderTypeDict() {
  return _loadWorkOrderTypeDict.apply(this, arguments);
}

/**
 * 获取工单类型树
 *
 * @param params {Object<{ status: number, hide: number, workOrderTypeCode: string }>}
 * @return {Promise<Array>}
 */
function _loadWorkOrderTypeDict() {
  _loadWorkOrderTypeDict = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var params,
      valueKey,
      data,
      _args2 = arguments;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          params = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          valueKey = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 'code';
          _context2.prev = 2;
          _context2.next = 5;
          return request({
            url: 'api/workOrderType/select',
            method: 'get',
            params: _objectSpread({
              parentId: '-1'
            }, params)
          });
        case 5:
          data = _context2.sent;
          return _context2.abrupt("return", (data || []).map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              value: item[valueKey],
              label: item.name
            });
          }));
        case 9:
          _context2.prev = 9;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", []);
        case 12:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[2, 9]]);
  }));
  return _loadWorkOrderTypeDict.apply(this, arguments);
}
export function loadWorkOrderTypeTree() {
  return _loadWorkOrderTypeTree.apply(this, arguments);
}

/**
 * 获取工单类型绑定资源树
 *
 * @param params {Object<{ workOrderTypeCode: string, areaId: string }>}
 * @return {Promise<Array>}
 */
function _loadWorkOrderTypeTree() {
  _loadWorkOrderTypeTree = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var params,
      data,
      _args3 = arguments;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          params = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          if (!(!params || !params.workOrderTypeCode)) {
            _context3.next = 3;
            break;
          }
          return _context3.abrupt("return", []);
        case 3:
          _context3.prev = 3;
          _context3.next = 6;
          return request({
            url: 'api/workOrderType/tree',
            method: 'post',
            data: params
          });
        case 6:
          data = _context3.sent;
          return _context3.abrupt("return", data || []);
        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3["catch"](3);
          return _context3.abrupt("return", []);
        case 13:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[3, 10]]);
  }));
  return _loadWorkOrderTypeTree.apply(this, arguments);
}
export function loadWorkOrderResourceTree(_x) {
  return _loadWorkOrderResourceTree.apply(this, arguments);
}
function _loadWorkOrderResourceTree() {
  _loadWorkOrderResourceTree = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(params) {
    var res, _formatNode;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (!(!params || !params.workOrderTypeCode)) {
            _context4.next = 2;
            break;
          }
          return _context4.abrupt("return", []);
        case 2:
          _context4.prev = 2;
          _context4.next = 5;
          return request({
            url: 'api/workOrderType/query-resources-tree',
            method: 'post',
            data: params
          });
        case 5:
          res = _context4.sent;
          _formatNode = function formatNode() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            data.forEach(function (node) {
              var leaf = !node.children || node.children.length === 0;
              node.leaf = leaf;
              if (leaf) {
                delete node.children;
              } else {
                _formatNode(node.children);
              }
            });
            return data;
          };
          return _context4.abrupt("return", _formatNode(res));
        case 10:
          _context4.prev = 10;
          _context4.t0 = _context4["catch"](2);
          return _context4.abrupt("return", []);
        case 13:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[2, 10]]);
  }));
  return _loadWorkOrderResourceTree.apply(this, arguments);
}
export default {
  add: add,
  edit: edit,
  del: del,
  create: create,
  status: status,
  selectedResourceIds: selectedResourceIds,
  bindResource: bindResource,
  bindCompany: bindCompany,
  loadWorkOrderTypeDict: loadWorkOrderTypeDict,
  loadWorkOrderTypeTree: loadWorkOrderTypeTree,
  loadWorkOrderResourceTree: loadWorkOrderResourceTree
};